{
  "en": {
    "models": {
      "image": {
        "background": "Use as Background?",
        "enabled": "Enabled?",
        "global": "Global?",
        "delete": "Delete",
        "start": "Start",
        "cancel": "Cancel",
        "processing": "Processing...",
        "error": "Error",
        "name": "Name",
        "size": "File size",
        "dropzone": "Drop images here"
      }
    }
  }
}
